import Phaser from 'phaser';
import { TextureGenerator } from '../Assets/Resources/TextureGenerator';
import { SettingsManager } from '../Scripts/Systems/SettingsManager';
import { AudioManager } from '../Scripts/Systems/AudioManager';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  public create(): void {
    SettingsManager.init();
    AudioManager.init();

    // Generate dynamic 16-bit pixel placeholders
    TextureGenerator.generateAll(this);

    this.scene.start('MainMenuScene');
  }
}
